<template>

  <!-- <div class="label">
            <span>指示器：</span> <el-radio v-model="radio" label="1">显示</el-radio>
            <el-radio v-model="radio" label="2">不显示</el-radio>
          </div> -->
  <div class="table">
    <el-table :data="editData.moduleList" style="width: 100%">
      <el-table-column label="图标">
        <template slot-scope="scope">
          <img :src="scope.row.imgUrl" class="imgsize" />
        </template>
      </el-table-column>
      <el-table-column label="标题" prop="chtitle">
      </el-table-column>
      <el-table-column label="简介" prop="content" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="updateopen(scope.$index)">编辑</el-button> -->
          <el-button type="text" size="mini">
            <el-popconfirm title="确定删除该条信息吗？" @confirm="deleteData(scope.$index)">
              <span slot="reference" style="color: #ff0000;"> 删除</span>
            </el-popconfirm>

          </el-button>
        </template>

      </el-table-column>

    </el-table>
    <div class="addType" style="padding: 10px 0;" @click="addnewData">
      <i class="el-icon-plus avatar-uploader-icon">添加数据</i>
    </div>
    <el-dialog class="editUp" :append-to-body="true" center :visible.sync="dialogFormVisible" width="40%">
      <div slot="title" class="title">
        <span>编辑</span>
      </div>
      <PainSpotEdit :closedialog="closedialogs" :indexs="indexs" v-if="dialogFormVisible" />
    </el-dialog>
    <div class="dialog-Btn">
      <el-button size="small" @click="closedialog">取消</el-button>
      <el-button size="small" type="primary" @click="updateData">保存</el-button>
    </div>

  </div>
</template>
  
<script>
import { addProgrammeCustomDetail } from "@/api/pageTemplate.js";

import PainSpotEdit from './painSpot_edit.vue'
export default {
  name: 'painSpot_add',
  props: {
    closedialog: {
      type: Function,
      default: () => { }
    }
  },
  components: {
    PainSpotEdit
  },
  data () {
    return {
      form: {},
      saveData: {},
      editData: [],
      moduleData: {},
      indexs: 0,
      dialogFormVisible: false
    }
  },
  created () {
    this.$nextTick(() => {
      this.editData = JSON.parse(this.$store.state.pageTemplateData.customDetailList[2].content)
      this.moduleData = JSON.parse(this.$store.state.pageTemplateData.customDetailList[2].content).moduleList[this.indexs]
      this.saveData = this.$store.state.pageTemplateData.customDetailList[2]
    })
  },
  mounted () {

  },

  methods: {
    updateopen (indexs) {

      this.indexs = indexs;
      this.dialogFormVisible = true
    },
    closedialogs () {
      this.dialogFormVisible = false

    },
    //删除数据
    deleteData (index) {
      this.editData.moduleList.splice(index, 1)
      // console.log(this.moduleData)
      // this.updateData()
    },
    addnewData () {
      this.editData.moduleList.push({
        imgUrl: '',
        chtitle: '请编辑',
        content: ''
      })
      // this.updateData()
    },
    updateData () {
      // this.editData.moduleList[this.indexs] = this.moduleData
      this.saveData.content = JSON.stringify(this.editData)
      addProgrammeCustomDetail(this.saveData).then(res => {
        if (res.data == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.closedialog()
          this.$store.commit('changeRefresh')
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },


  }
}
</script>
  
<style lang="scss" scoped>
.boxs {
  position: absolute;
  left: 0;
  top: 60px;
  width: 100%;
  height: 100%;

  .item {
    padding: 5px 10px;
    background: #007ffe;
    font-style: normal;
    align-items: center;
    display: none;

    cursor: pointer;
    color: #fff;

    &:first-child {
      border-bottom-right-radius: 4px;
    }
  }

  &:hover {
    .item {
      display: inline-flex;
      font-size: 14px;
    }
  }
}

.formGrids {
  display: grid;
  justify-content: space-between;
  grid-template-columns: calc(50% - 20px) calc(50% - 20px);
  grid-column-gap: 20px;
}

::v-deep .editUp {
  position: absolute;
  left: 0;

  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;

    span {
      &:nth-child(2) {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .label {
    display: flex;
    align-items: center;
  }

  .table {
    margin-top: 20px;
    max-height: 600px;
    overflow: hidden;
    overflow-y: auto;

    .img {
      width: 100px;
      height: 50px;
    }
  }

  .dialog-foote {
    text-align: center;
    display: flex;
    justify-content: center;
  }
}
.imgsize {
  width: 32px;
  height: 32px;
}
.addType {
  text-align: center;
  border: 1px dashed #ddd;

  height: 100%;
  width: 100%;
  span {
    margin-left: 5px;
  }
}
.dialog-Btn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>